import assetExpLoanShortnameDataset from "../../datasets/asset_exp_loan__shortname_dataset";


export const addChangeSalaryAsset = (assetTable, shortName, salaryStartDate, salaryIncrease,
      descAddLit) => {
   let totalSalary = salaryIncrease;
   let shortNameObj = assetExpLoanShortnameDataset.find(elem => elem.shortName === shortName);
   let bonusIndx = -1;
   let newAssetTable = JSON.parse(JSON.stringify(assetTable));
   for (let i=0; i<newAssetTable.length; i++){
      if (+newAssetTable[i].assetNbrMonths !== 0 ){
         if (newAssetTable[i].assetItem === shortNameObj.fullName){
             bonusIndx = i;
         }
         totalSalary = +totalSalary + +newAssetTable[i].assetAmt;
      }
   }
   if (bonusIndx === -1){
         let assetObj = {assetItem: shortNameObj.fullName, 
            assetDesc: shortNameObj.desc + descAddLit, 
            assetAmt: salaryIncrease, assetStartDate: salaryStartDate, assetNbrMonths: -1};
         newAssetTable.push(assetObj);
   }else{
         newAssetTable[bonusIndx].assetDesc +=  ", " + descAddLit;
         let newSalaryAmt =  +newAssetTable[bonusIndx].assetAmt +  +salaryIncrease;
         newAssetTable[bonusIndx].assetAmt = newSalaryAmt.toString();
   }
   
   let returnObj = {assetTable: newAssetTable, totalSalary: totalSalary}; 
   return returnObj;
   
}
